// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 16) return "static/js/8c4bf5e63c775a15fc4e.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bcf97580a27334d1f2da","124":"149aecd6ef4a14fb687e","125":"49e18b752ebc2984cd41"}[chunkId] + ".chunk.js";
};